/**
 * Слой укрытий с занятостью на карте ЧС (Resilience-демо): маркеры «37 / 120»,
 * полные — серые, тап — перевыбор укрытия (маршрут перестраивается в панели).
 */
import { getLang } from '@app/i18n'
import { type EscapePlan, localized, type Venue } from '@app/rvf'
import { useEffect } from 'preact/hooks'
import type { EmergencyFrame } from '../emergency/frame'
import type { VenueMap } from '../map/venue-map'

export function useShelterLayer(opts: {
  map: VenueMap | null
  v: Venue | null
  mapVisible: boolean
  frame: EmergencyFrame | null
  shelterId: string | null
  escapePlan: EscapePlan | null
  onPick: (id: string) => void
}): void {
  const { map, v, mapVisible, frame, shelterId, escapePlan, onPick } = opts
  useEffect(() => {
    if (!map || !v) return
    const shelters = v.evacuation?.shelters ?? []
    if (!mapVisible || frame?.mode !== 1 || shelters.length === 0) {
      map.setShelters(null)
      return
    }
    const activeId =
      shelterId ?? shelters.find((sh) => sh.node === escapePlan?.targetNodeId)?.id ?? null
    map.setShelters(
      shelters.map((sh) => ({
        id: sh.id,
        point: sh.point,
        label: localized(sh.name, getLang(), v.venue.default_language),
        ...(sh.capacity !== undefined ? { capacity: sh.capacity } : {}),
        ...(sh.occupancy !== undefined ? { occupancy: sh.occupancy } : {}),
      })),
      activeId,
      onPick,
    )
    return () => map.setShelters(null)
  }, [map, v, mapVisible, frame, shelterId, escapePlan])
}
